import { useMemo } from 'react';
import { ThreadMessage } from '@assistant-ui/react';

export const useTextFromMessage = (
  message: ThreadMessage | undefined | null,
) => {
  return useMemo(() => {
    if (!message) {
      return '';
    }

    const texts = message.content
      .filter(content => content.type === 'text')
      .map(content => content.text);

    return texts.join(' ');
  }, [message]);
};
